/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CloseIcon = (props: Props) => (
  <svg
    className={classNames("icons", "cursor-pointer", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="3 3 18 18"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.5,4.5 L19.5,19.5" />
      <path d="M19.5,4.5 L4.5,19.5" />
    </g>
  </svg>
);

export default CloseIcon;
